import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-service-filter',
  templateUrl: './service-filter.component.html',
  styleUrls: ['./service-filter.component.scss']
})
export class ServiceFilterComponent implements OnInit {

   roleOptions = [
    { title: 'Anonymous', value: 'ROLE_ANON', active: true },
    { title: 'Vorkunde', value: 'ROLE_PRE_CUSTOMER', active: true },
    { title: 'Kunde/Mitarbeiter', value: 'ROLE_CUSTOMER', active: true },
    { title: 'Aktionspartner', value: 'ROLE_PARTNER', active: true },
    { title: 'Sachbearbeiter', value: 'ROLE_CASEWORKER', active: true },
    { title: 'Administrator', value: 'ROLE_ADMIN', active: true }
  ];
  
   stateOptions = [
    { title: 'aktiviert', value:'ACTIVE', active: false },
    { title: 'deaktiviert', value: 'DISABLED', active: false }
  ];

   moduleOptions = [
    { title: 'Aktionswelt', value:'event', active: false },
    { title: 'Infothek', value:'news', active: false },
    { title: 'Karte', value:'card', active: false }
  ];

  @Output() filterChanged = new EventEmitter<any>();

  filterForm: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.filterForm = this.fb.group({
      filterByRoles: this.fb.array(
        this.roleOptions.map(control => new UntypedFormControl(control.active))
      ),
      filterByStates: this.fb.array(
        this.stateOptions.map(control => new UntypedFormControl(control.active))
      ),
      searchTerm: '',
      filterByModules: this.fb.array(
        this.moduleOptions.map(control => new UntypedFormControl(control.active))
      )
    });

    this.filterForm.valueChanges.subscribe(res => {
      this.updateFilter();
    });
  }

  updateFilter() {
    const filter = {
      searchTerm: this.filterForm.value.searchTerm,
      filterByRoles: this.filterForm.value.filterByRoles.map((active, index) => {
        if (active) {
          return this.roleOptions[index].value;
        }
      }).filter(val => !!val),
      filterByStates: this.filterForm.value.filterByStates.map((active, index) => {
        if (active) {
          return this.stateOptions[index].value;
        }
      }).filter(val => !!val),
      filterByModules: this.filterForm.value.filterByModules.map((active, index) => {
        if (active) {
          return this.moduleOptions[index].value;
        }
      }).filter(val => !!val)
    }

    this.filterChanged.emit(filter);
  }

}
